<app-spinner></app-spinner>
<div class="verifier-container">
    <h3 class="Admin-Dashboard px-3">Dashboard</h3>
    <div class="row px-3">
        <div class="col-lg-3 col-md-6 col-sm-12 col-12" style="cursor: pointer;">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/dashboard']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>Total Complaints</mat-card-title>
                    <mat-icon><span style="color: #7A7FA1; background-color: none;">insert_chart</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{total_complaints}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <!-- <mat-chip-set aria-label="Chihuahua traits">

                        <mat-chip>charming</mat-chip>
                        <mat-chip>graceful</mat-chip>
                        <mat-chip>sassy</mat-chip>
                    </mat-chip-set> -->

                    <p style="padding-left: 17px;">For your Department</p>
                </mat-card-footer>
            </mat-card>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 col-12" style="cursor: pointer;">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/pending-complaints']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>Pending
                    </mat-card-title>
                    <mat-icon><span style="color:#B19D0A">schedule</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{pending_count}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <p style="padding-left: 17px;">Awaiting Action</p>
                </mat-card-footer>
            </mat-card>

        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/resolved-complaints']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>Resolved
                    </mat-card-title>
                    <mat-icon><span style="color: #00A90B">check_circle</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{resolved_count}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <p style="padding-left: 17px;">Successfully Completed</p>
                </mat-card-footer>
            </mat-card>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 col-12">
            <mat-card class="example-card" appearance="outlined" [routerLink]="['/sdp/officer/escalated-complaints']">
                <mat-card-header class="common-card-header">
                    <mat-card-title>Escalated
                    </mat-card-title>
                    <mat-icon><span style="color: #F52525">warning</span></mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <span class="one">{{total_escalated}}</span>
                </mat-card-content>
                <mat-card-footer class="example-card-footer">
                    <p style="padding-left: 17px;">Elevated to higher level</p>
                </mat-card-footer>
            </mat-card>
        </div>
    </div>
    <div class="row my-5 px-3">
        <div class="col-12">
            <div class="shadow-wrapper">
                <div>
                    <h2 class="py-3">Total Complaints</h2>
                </div>
                <div *ngIf="complaints.data.length > 0; else noData" style="overflow-x: auto;">
                    <input type="text" class="form-control fontAwesome mb-2"
                        style="padding: 8px;margin-bottom: 10px;  width: 100% !important;"
                        (keyup)="applyFilter($any($event.target).value)" placeholder="Search">
                    <table mat-table [dataSource]="complaints" class="mat-elevation-z8" style="width: 100%;">

                        <!-- ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef>Sr.No.</th>
                            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                        </ng-container>

                        <!-- Ticket Id Column -->
                        <ng-container matColumnDef="ticket_id">
                            <th mat-header-cell *matHeaderCellDef>Ticket Id</th>
                            <td mat-cell *matCellDef="let element">{{ element.ticket_id }}</td>
                        </ng-container>

                        <!-- Date & Time Column -->
                        <ng-container matColumnDef="dateTime">
                            <th mat-header-cell *matHeaderCellDef>Created Date</th>
                            <td mat-cell *matCellDef="let element">{{ element.create_date }}</td>
                        </ng-container>

                        <!-- Zone Column -->
                        <ng-container matColumnDef="zone">
                            <th mat-header-cell *matHeaderCellDef>Zone</th>
                            <td mat-cell *matCellDef="let element">{{ element.zone }}</td>
                        </ng-container>


                        <!-- Days Open Column -->
                        <ng-container matColumnDef="days_open">
                            <th mat-header-cell *matHeaderCellDef>Days Open</th>
                            <td mat-cell *matCellDef="let element">{{ element.number_of_open_days }}</td>
                        </ng-container>


                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">{{ element.status}}</td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let element; let i = index">
                                <div class="d-flex justify-content-center align-items-center">
                                    <h6 style="color: rgb(0, 26, 255); text-decoration: underline; cursor: pointer;"
                                        class="mt-2 view" (click)="route1(element)"
                                        matTooltip="View detailed information">
                                        View More
                                    </h6>


                                    <mat-icon style="cursor: pointer; vertical-align: middle; margin-left: 10px; color: rgb(0, 26, 255);" class="more-options-icon"
                                        [matMenuTriggerFor]="menu" matTooltip="More options">
                                        more_vert
                                    </mat-icon>
                                </div>


                                <mat-menu #menu="matMenu">
                                    <!-- <h6 mat-menu-item *ngIf="['PENDING', 'RESOLVED'].includes(element.status)"
                                        (click)="route(element)">
                                        <span
                                            style="color: rgb(134, 134, 135); text-decoration: underline;cursor: pointer; font-size: 14px;">Update</span>
                                    </h6> -->

                                    <h6 mat-menu-item (click)="onDownloadPDF(element)">
                                        <span
                                            style="color: rgb(1, 159, 244); text-decoration: underline;cursor: pointer; font-size: 14px;">Print
                                            Form</span>
                                    </h6>
                                </mat-menu>
                            </td>



                        </ng-container>
                        <!-- Table Headers and Rows -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
                <div class="paginator-wrapper">
                    <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons
                        aria-label="Select page of periodic elements">
                    </mat-paginator>
                </div>
            </div>
            <ng-template #noData>
                <div class="text-center my-4 " style="font-size: 18px; color: gray;">
                    Records not found!!
                </div>
            </ng-template>
        </div>
    </div>

</div>